import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../Api";


export const getApplicationError = createAsyncThunk("getApplicationError", async (d) => {
    try {
        const res = await api.get(`${process.env.REACT_APP_BASE_URL}/error/log`);

          return { data: res.data.results };
    } catch (error) {
         throw error; 
    }
});
export const updateApplicationError = createAsyncThunk("updateApplicationError", async (d,{dispatch}) => {
    try {
        const res = await api.post(`${process.env.REACT_APP_BASE_URL}/error/readlog`,{
            logIndex:d
        });
       await dispatch(getApplicationError())
          return { };
    } catch (error) {
         throw error; 
    }
});
export const getClasseError = createAsyncThunk("getClasseError", async (d) => {
    try {
        const res = await api.get(`${process.env.REACT_APP_BASE_URL}/error/findall`);

          return { data: res.data.results };
    } catch (error) {
         throw error; 
    }
});
export const updateClasseError = createAsyncThunk("updateClasseError", async (d,{dispatch}) => {
    try {
        const res = await api.post(`${process.env.REACT_APP_BASE_URL}/error/markread`,{
            logIndex:d
        });
       await dispatch(getClasseError())
          return { };
    } catch (error) {
         throw error; 
    }
});
export const getSkyPrepError = createAsyncThunk("getSkyPrepError", async (d) => {
    try {
        const res = await api.get(`${process.env.REACT_APP_BASE_URL}/error/findsky`);

          return { data: res.data.results };
    } catch (error) {
         throw error; 
    }
});
export const updateSkyPrepError = createAsyncThunk("updateSkyPrepError", async (d,{dispatch}) => {
    try {
        const res = await api.post(`${process.env.REACT_APP_BASE_URL}/error/marksky`,{
            logIndex:d
        });
       await dispatch(getSkyPrepError())
          return { };
    } catch (error) {
         throw error; 
    }
});

 
const errorSlice = createSlice({
  name: "schedule",
  initialState: {
    app_error:{},
    classe_error:{},
    skyprep_error:{},
    isLoading: false,
    isError: false,
    errMsg: "",
  },
  reducers: {
    
  },
  extraReducers: (builder) => {
    builder.addCase(getApplicationError.pending, (state) => {
      state.isLoading = true;
     });
    builder.addCase(getApplicationError.fulfilled, (state, action) => {
      state.isLoading = false;
      state.app_error = action.payload.data;  
     });
    builder.addCase(getApplicationError.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errMsg = "Error Occurred";
     });
    builder.addCase(updateApplicationError.pending, (state) => {
      state.isLoading = true;
     });
    builder.addCase(updateApplicationError.fulfilled, (state, action) => {
      state.isLoading = false;
      
     });
    builder.addCase(updateApplicationError.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errMsg = "Error Occurred";
     });

    //  Classe
    builder.addCase(getClasseError.pending, (state) => {
        state.isLoading = true;
       });
      builder.addCase(getClasseError.fulfilled, (state, action) => {
        state.isLoading = false;
        state.classe_error = action.payload.data;  
       });
      builder.addCase(getClasseError.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errMsg = "Error Occurred";
       });
      builder.addCase(updateClasseError.pending, (state) => {
        state.isLoading = true;
       });
      builder.addCase(updateClasseError.fulfilled, (state, action) => {
        state.isLoading = false;
        
       });
      builder.addCase(updateClasseError.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errMsg = "Error Occurred";
       });
    // Sky Prep
    builder.addCase(getSkyPrepError.pending, (state) => {
        state.isLoading = true;
       });
      builder.addCase(getSkyPrepError.fulfilled, (state, action) => {
        state.isLoading = false;
        state.skyprep_error = action.payload.data;  
       });
      builder.addCase(getSkyPrepError.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errMsg = "Error Occurred";
       });
      builder.addCase(updateSkyPrepError.pending, (state) => {
        state.isLoading = true;
       });
      builder.addCase(updateSkyPrepError.fulfilled, (state, action) => {
        state.isLoading = false;
        
       });
      builder.addCase(updateSkyPrepError.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errMsg = "Error Occurred";
       });
  }
  
});
 
 export  const errorReducer = errorSlice.reducer;
